/**
 * See here for docs
 * https://anseki.github.io/plain-draggable/
 * Had to clone repo to get dependencies loaded correctly (they were in devDependencies).
 * Other than that, no changes.
 *
 * On touch devices, the handle will disable any buttons inside it. To get around this you can include
 * the 'data-drag-handle' attribute on the nested element you wish to use as the handler.
 */

const NS = 'Draggable';

export default function Draggable($timeout) {
  "ngInject";


  return {
    restrict: 'A',
    //The link function is responsible for registering DOM listeners as well as updating the DOM. test
    link: function (scope, element, attrs) {

      let draggable;
      $timeout(() => { // timeout needed to access DOM elements after render
        const target = element[0];
        let handle = element[0].querySelector(attrs.draggable);
        let nestedHandle = handle.querySelector('[data-drag-handle]');
        if (nestedHandle) {
          handle = nestedHandle;
        }

        try {
          // plain-draggable/plain-draggable.min.js gets added in the `src/npm_components/angularjs-bundle.js` as part of `node-scripts/bundle-angularjs.js`
          draggable = new window.PlainDraggable(target, {
            handle,
            sensitivity: [0,0,0]
          });
        } catch (error) {
          console.warn('Error initializing PlainDraggable', error);

        }

      }, 2000); // must be at least zero, but modals sometimes take awhile to display full height

      scope.$on('$destroy', function () {
        if (draggable) {
          draggable.remove();
        }
      });
    }
  };
}

